import { CategoryPreviewResponse, SourceCatalogPage } from '@domains/categories';

import { NewProductsPageSlug, PromoPageSlug } from '@utils/constants';
import {
    makeCategoryRoute,
    makeNewProductsCategoryRoute,
    makePromoCategoryRoute,
} from '@utils/route';

export const findCategoryParents = (
    categoryId: number,
    categories: CategoryPreviewResponse[],
): CategoryPreviewResponse[] => {
    const category = categories.find(({ id }) => id === categoryId);
    if (category === undefined) {
        return [];
    }

    if (category.parent_id === null) {
        return [category];
    }

    const parent = findCategoryParents(category.parent_id, categories);
    return [...parent, category];
};

export const makeCategoryRouteFromSource = (slug: string, source?: SourceCatalogPage) => {
    if (source === PromoPageSlug) return makePromoCategoryRoute(slug);
    else if (source === NewProductsPageSlug) return makeNewProductsCategoryRoute(slug);
    else return makeCategoryRoute(slug);
};
